import React from 'react';
import Alert from "@material-ui/lab/Alert/Alert";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Typography from '@material-ui/core/Typography';

const HelperText = ({message}) => {
    return (
        <Alert icon={<HelpOutlineIcon fontSize="inherit" />} severity="info">
            <Typography variant="body2">{message}</Typography>
        </Alert>
    );
};
export default HelperText;